import { defineMessages } from "react-intl";
const scope = "app.aiDiscoverability.reportTypes.cards";
export default defineMessages({
    basicPlanTitle: {
        id: `${scope}.basicPlanTitle`,
        defaultMessage: "BASIC",
    },
    basicPlanSubtitleGeminiMonthlyReports: {
        id: `${scope}.basicPlanSubtitleGeminiMonthlyReports`,
        defaultMessage: "Gemini Model, Monthly Reports",
    },
    basicPlanPriceValueFreeAmount: {
        id: `${scope}.basicPlanPriceValueFreeAmount`,
        defaultMessage: "$0",
    },
    basicPlanPriceInlineFirstTwoMonthlyReportsFree: {
        id: `${scope}.basicPlanPriceInlineFirstTwoMonthlyReportsFree`,
        defaultMessage: "For your first 2 monthly reports",
    },
    basicPlanPriceSubLabelThenTwentyFivePerReportMonthly: {
        id: `${scope}.basicPlanPriceSubLabelThenTwentyFivePerReportMonthly`,
        defaultMessage: "then $25/report per month, cancel anytime",
    },
    basicPlanPrimaryActionGetBasicReports: {
        id: `${scope}.basicPlanPrimaryActionGetBasicReports`,
        defaultMessage: "Get Basic Reports",
    },
    basicPlanFeaturesSectionTitle: {
        id: `${scope}.basicPlanFeaturesSectionTitle`,
        defaultMessage: "Basic Reports Include:",
    },
    basicPlanFeatureFirstReportFreeForTwoMonths: {
        id: `${scope}.basicPlanFeatureFirstReportFreeForTwoMonths`,
        defaultMessage: "First report free for 2 months",
    },
    basicPlanFeatureGeminiOnlyVisibilityTracking: {
        id: `${scope}.basicPlanFeatureGeminiOnlyVisibilityTracking`,
        defaultMessage: "Gemini only visibility tracking",
    },
    basicPlanFeatureMonthlyReports: {
        id: `${scope}.basicPlanFeatureMonthlyReports`,
        defaultMessage: "Monthly Reports",
    },
    basicPlanFeatureCompetitorAnalysis: {
        id: `${scope}.basicPlanFeatureCompetitorAnalysis`,
        defaultMessage: "Competitor Analysis",
    },
    basicPlanPriceValueTwentyOneTwentyFive: {
        id: `${scope}.basicPlanPriceValueTwentyOneTwentyFive`,
        defaultMessage: "$21.25",
    },
    basicPlanPriceValueTwentyFiveDollars: {
        id: `${scope}.basicPlanPriceValueTwentyFiveDollars`,
        defaultMessage: "$25",
    },
    basicPlanPriceInlinePerReportPerMonth: {
        id: `${scope}.basicPlanPriceInlinePerReportPerMonth`,
        defaultMessage: "/report per month",
    },
    basicPlanPriceSubLabelBilledAnnually: {
        id: `${scope}.basicPlanPriceSubLabelBilledAnnually`,
        defaultMessage: "Billed Annually",
    },
    basicPlanPriceSubLabelBilledMonthly: {
        id: `${scope}.basicPlanPriceSubLabelBilledMonthly`,
        defaultMessage: "Billed Monthly",
    },
    basicPlanBillingOptionAnnually: {
        id: `${scope}.basicPlanBillingOptionAnnually`,
        defaultMessage: "Annually",
    },
    basicPlanBillingOptionDiscountFifteenPercentOff: {
        id: `${scope}.basicPlanBillingOptionDiscountFifteenPercentOff`,
        defaultMessage: "15% off",
    },
    basicPlanBillingOptionMonthly: {
        id: `${scope}.basicPlanBillingOptionMonthly`,
        defaultMessage: "Monthly",
    },
    premiumPlanTitle: {
        id: `${scope}.premiumPlanTitle`,
        defaultMessage: "PREMIUM",
    },
    premiumPlanSubtitleAllModelsMonthlyReportsAndCustomTopics: {
        id: `${scope}.premiumPlanSubtitleAllModelsMonthlyReportsAndCustomTopics`,
        defaultMessage: "All AI Models, Monthly Reports & Custom Topics",
    },
    premiumPlanPriceValueEightyFiveDollars: {
        id: `${scope}.premiumPlanPriceValueEightyFiveDollars`,
        defaultMessage: "$85",
    },
    premiumPlanPriceValueOneHundredDollars: {
        id: `${scope}.premiumPlanPriceValueOneHundredDollars`,
        defaultMessage: "$100",
    },
    premiumPlanPriceInlinePerReportPerMonth: {
        id: `${scope}.premiumPlanPriceInlinePerReportPerMonth`,
        defaultMessage: "/report per month",
    },
    premiumPlanPriceSubLabelBilledAnnually: {
        id: `${scope}.premiumPlanPriceSubLabelBilledAnnually`,
        defaultMessage: "Billed Annually",
    },
    premiumPlanPriceSubLabelBilledMonthly: {
        id: `${scope}.premiumPlanPriceSubLabelBilledMonthly`,
        defaultMessage: "Billed Monthly",
    },
    premiumPlanPrimaryActionGetPremiumReports: {
        id: `${scope}.premiumPlanPrimaryActionGetPremiumReports`,
        defaultMessage: "Get Premium Reports",
    },
    premiumPlanFeaturesSectionTitle: {
        id: `${scope}.premiumPlanFeaturesSectionTitle`,
        defaultMessage: "Premium Reports Include:",
    },
    premiumPlanFeatureAllAiModels: {
        id: `${scope}.premiumPlanFeatureAllAiModels`,
        defaultMessage: "All AI models",
    },
    premiumPlanFeatureCustomizableTopics: {
        id: `${scope}.premiumPlanFeatureCustomizableTopics`,
        defaultMessage: "Customizable topics",
    },
    premiumPlanFeatureMonthlyReports: {
        id: `${scope}.premiumPlanFeatureMonthlyReports`,
        defaultMessage: "Monthly Reports",
    },
    premiumPlanFeatureDetailedCompetitorAnalysis: {
        id: `${scope}.premiumPlanFeatureDetailedCompetitorAnalysis`,
        defaultMessage: "Detailed Competitor Analysis",
    },
    premiumPlanRecommendedLabel: {
        id: `${scope}.premiumPlanRecommendedLabel`,
        defaultMessage: "Recommended",
    },
    premiumPlanBillingOptionAnnually: {
        id: `${scope}.premiumPlanBillingOptionAnnually`,
        defaultMessage: "Annually",
    },
    premiumPlanBillingOptionDiscountFifteenPercentOff: {
        id: `${scope}.premiumPlanBillingOptionDiscountFifteenPercentOff`,
        defaultMessage: "15% off",
    },
    premiumPlanBillingOptionMonthly: {
        id: `${scope}.premiumPlanBillingOptionMonthly`,
        defaultMessage: "Monthly",
    },
    enterprisePlanTitle: {
        id: `${scope}.enterprisePlanTitle`,
        defaultMessage: "ENTERPRISE",
    },
    enterprisePlanSubtitleLargeOrganizationRollout: {
        id: `${scope}.enterprisePlanSubtitleLargeOrganizationRollout`,
        defaultMessage: "Large Organization Rollout",
    },
    enterprisePlanPriceValueContactSales: {
        id: `${scope}.enterprisePlanPriceValueContactSales`,
        defaultMessage: "Contact Sales",
    },
    enterprisePlanPriceSubLabelTailoredToPortfolioSize: {
        id: `${scope}.enterprisePlanPriceSubLabelTailoredToPortfolioSize`,
        defaultMessage: "Tailored to your portfolio size",
    },
    enterprisePlanPrimaryActionGetInTouch: {
        id: `${scope}.enterprisePlanPrimaryActionGetInTouch`,
        defaultMessage: "Get In Touch",
    },
    enterprisePlanFeaturesSectionTitleIncludesEverythingInPremiumPlus: {
        id: `${scope}.enterprisePlanFeaturesSectionTitleIncludesEverythingInPremiumPlus`,
        defaultMessage: "Includes everything in Premium with the addition of:",
    },
    enterprisePlanFeatureCommunityLevelBilling: {
        id: `${scope}.enterprisePlanFeatureCommunityLevelBilling`,
        defaultMessage: "Community level billing",
    },
    enterprisePlanFeatureWhiteGloveImplementation: {
        id: `${scope}.enterprisePlanFeatureWhiteGloveImplementation`,
        defaultMessage: "White glove implementation",
    },
    enterprisePlanFeaturePayByInvoice: {
        id: `${scope}.enterprisePlanFeaturePayByInvoice`,
        defaultMessage: "Pay by invoice",
    },
    enterprisePlanFeatureCustomReportFrequency: {
        id: `${scope}.enterprisePlanFeatureCustomReportFrequency`,
        defaultMessage: "Custom Report frequency",
    },
});
